import React, { useState } from "react";
import {
  Button
} from "antd";
import { v4 as uuidv4 } from "uuid";
 
 
// ** Components
import MultiKitProductGroup from "./MultiKitProductGroup";
// Component to manage a list of MultiKit Product Groups
const MultiKitProductGroupList = ({ store_id, form, kitProduct, setInnerProducts, innerProducts }) => {
 
 
 
  const [lastOpenGroupId, setLastOpenGroupId] = useState(null);
 
  const addGroup = () => {
    const current = innerProducts?.multi_kit_prods || [];
    const nextGroup = { id: uuidv4(), products: [{
      unique_id: uuidv4()
    }] }; // unique id for React key
    const next = [...current, nextGroup];
 
    setInnerProducts(prev => ({
      ...prev,
      multi_kit_prods: next
    }));
    setLastOpenGroupId(nextGroup.id);
   
    // Form update  
    const currentForm = form.getFieldValue("multi_kit_prods") || [];
    const nextForm = [...currentForm, nextGroup];
    form.setFieldsValue({ multi_kit_prods: nextForm });
  };
 
 
  const removeGroup = (id) => {
    const current = innerProducts.multi_kit_prods || [];
   
   
    // Remove the group from the innerProducts
    const next = current.filter((item) => item.id !== id);
 
   
    // Update form and innerProducts directly
    // form.setFieldsValue({ multi_kit_prods: next });
   
    setInnerProducts(prev => ({
      ...prev,
      multi_kit_prods: next
    }));
 
    // Form update
    const currentForm = form.getFieldValue("multi_kit_prods") || [];
    const nextForm = currentForm.filter((item) => item.id !== id);
    form.setFieldsValue({ multi_kit_prods: nextForm });
  };
 
 
  return (
    <>
      {innerProducts?.multi_kit_prods?.map((groupData, index) => {
        return (
        <MultiKitProductGroup
          store_id={store_id}
          form={form}
          kitProduct={kitProduct}
          key={groupData.id}
          groupId={groupData.id}
          index={index}
          totalGroups={innerProducts.multi_kit_prods.length}
          onDelete={() => removeGroup(groupData.id)}
          innerProducts={innerProducts}
          setInnerProducts={setInnerProducts}
          groupData={groupData}
          forceOpen={lastOpenGroupId === groupData.id}
        />
      )})}
      <div className="btnBox" style={{ marginTop: 16 }}>
        <Button onClick={addGroup}>+ Add Product Group</Button>
      </div>
    </>
  );
};
 
export default MultiKitProductGroupList;